// Client-side instrumentation — runs whenever a user loads a page.
//
// Error tracking, Core Web Vitals, and product analytics are all handled by
// PostHog. Initialisation, consent gating (analytics vs strictly-necessary),
// and the noise filter live in `lib/posthog.ts`; this file just boots it.

import { initPostHog } from '@/lib/posthog';

// PostHog product analytics + client-side error / Web Vitals capture.
// Fail-soft (no-op without NEXT_PUBLIC_POSTHOG_KEY) and consent-gated
// internally — see lib/posthog.ts.
initPostHog();
